import { useLocalStore } from 'mobx-react-lite';
import { RefObject, useRef } from 'react';

import Tasks from 'APP/Tasks';
import { OnboardingType } from 'APP/constants/onboarding';
import FileUploadButton from 'APP/main/ChatView/ChatFooter/InputPanel/AttachmentsButton/FileUploadButton';
import { Features } from 'APP/packages/features/Features';
import Entities from 'STORE';
import { Group } from 'STORE/Groups/Group';

interface IAttachmentsButtonPresenter {
  isMenuOpen: boolean;
  closeMenu(): void;
  toggleMenu(): void;
  uploadFile(files: File[]): void;
  group: Group | null;
  isShowOnboarding: boolean;
}

interface IAttachmentsButtonPresenterReturn {
  presenter: IAttachmentsButtonPresenter;
  attachmentsButtonRef: RefObject<HTMLButtonElement>;
  fileUploadRef: RefObject<FileUploadButton>;
}

export const useAttachmentsButtonPresenter = (): IAttachmentsButtonPresenterReturn => {
  const attachmentsButtonRef = useRef<HTMLButtonElement>(null);
  const fileUploadRef = useRef<FileUploadButton>(null);

  const presenter = useLocalStore<IAttachmentsButtonPresenter>(() => ({
    isMenuOpen: false,

    closeMenu(): void {
      presenter.isMenuOpen = false;
    },

    toggleMenu(): void {
      // ToDo - вернуть обратно, когда появятся дополнительные пункты в аттачментах
      // presenter.isMenuOpen = !presenter.isMenuOpen;
      fileUploadRef.current && fileUploadRef.current.open();
      Tasks.app.onboarding.closeOnboarding(OnboardingType.CreateFirstArticle);
    },

    uploadFile(files: File[]): void {
      if (!files || !files.length || !presenter.group) {
        return;
      }

      Tasks.messaging.sendFiles({
        groupId: presenter.group.id,
        files,
      });
    },

    get group(): Group | null {
      return Entities.GroupsStore.activeGroup;
    },

    get isShowOnboarding(): boolean {
      return (
        (presenter.group?.isChannel &&
          presenter.group?.withMeInAdmins &&
          Features.isArticleEnabled()) ||
        false
      );
    },
  }));

  return { presenter, attachmentsButtonRef, fileUploadRef };
};
